// Área Ferramentas (menu Gestão → Ferramentas): utilitários de uso geral da equipe interna.
// Acesso: adm, gerente e analista — a rota é guardada em App.tsx (RoleGuard `allowed`).
//
// Cada ferramenta é carregada sob demanda: o Dividir PDF traz o pdf.js, que é grande, e não pode
// entrar no pacote principal do sistema.

import React, { Suspense, lazy } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import LoadingSpinner from '../../src/components/LoadingSpinner';
import FerramentasHome from './FerramentasHome';

const DividirPdfView = lazy(() => import('./DividirPdf/DividirPdfView'));
const ConsultaDadosView = lazy(() => import('./ConsultaDados/ConsultaDadosView'));

const FerramentasLayout: React.FC = () => (
  <Suspense fallback={<LoadingSpinner label="Abrindo a ferramenta..." />}>
    <Routes>
      <Route index element={<FerramentasHome />} />
      <Route path="dividir-pdf" element={<DividirPdfView />} />
      <Route path="consulta-dados" element={<ConsultaDadosView />} />
      <Route path="*" element={<Navigate to="/ferramentas" replace />} />
    </Routes>
  </Suspense>
);

export default FerramentasLayout;
